export default __webpack_public_path__ + "static/media/atlier-workstation-landing-bg.21694268.png";